import React, { useState, useEffect, useRef } from 'react';
import { useSetPriceCurrency, useSetMinimumPrice, useSetPresetPrice, useUserCountry } from '../state';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const SelectCountry = ({ onCountryChange, className }) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const setPriceCurrency = useSetPriceCurrency();
  const setMinimumPrice = useSetMinimumPrice();
  const setPresetPrice = useSetPresetPrice();
  const userCountry = useUserCountry();
  const isFirstRender = useRef(true);

  // Reset isFirstRender when component mounts
  useEffect(() => {
    isFirstRender.current = true;
    return () => {
      isFirstRender.current = false;
    };
  }, []);

  useEffect(() => {
    if (isFirstRender.current && userCountry && countries.length > 0) {
      const country = countries.find(c => c.code === userCountry);
      if (country) {
        setSelectedCountry(country.code);
        setPriceCurrency(country.currency);
        setMinimumPrice(Number(country.minimumPrice));
        setPresetPrice(Number(country.presetPrice));
        onCountryChange(country.code);
      }
      isFirstRender.current = false;
    }
  }, [userCountry, countries, setPriceCurrency, setMinimumPrice, setPresetPrice, onCountryChange]);

  useEffect(() => {
    const getCountries = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${apiBaseUrl}/countries`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        console.log('data: ', data);
        setCountries(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error getting countries:', error);
        setIsLoading(false);
      }
    }

    getCountries();
  }, []);

  const handleChange = (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const countryCode = selectedOption.value;
    const currency = selectedOption.dataset.currency;
    const minimumPrice = selectedOption.dataset.minimumPrice;
    const presetPrice = selectedOption.dataset.presetPrice;

    console.log(`Select country component: Currency: ${currency}, minimum price: ${minimumPrice}, preset price: ${presetPrice}`);

    localStorage.setItem('priceCurrency', currency);
    localStorage.setItem('minimumPrice', minimumPrice);
    localStorage.setItem('presetPrice', presetPrice);

    setPriceCurrency(currency);
    setMinimumPrice(Number(minimumPrice));
    setPresetPrice(Number(presetPrice));
    setSelectedCountry(countryCode);
    onCountryChange(countryCode);
  };

  return (
    <div>
      <label htmlFor="country-select" className="text-white text-base">Select your country: </label>
      {isLoading ? (
        <p></p>
      ) : (
        <select
          id="country-select"
          value={selectedCountry}
          onChange={handleChange}
          className="w-full px-3 py-2 text-black text-base bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 mt-2"
        >
          {countries
            .sort((a, b) => a.country.localeCompare(b.country))
            .map((country) => (
              <option
                key={country.code}
                value={country.code}
                data-currency={country.currency}
                data-minimum-price={country.minimum}
                data-preset-price={country.preset}
              >
                {country.country}
              </option>
            ))}
        </select>
      )}
    </div>
  );
};

export default SelectCountry;
